import React, { useState, useRef, useEffect } from 'react';

import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import ClickAwayListener from 'react-click-away-listener';
import assets from 'assets';
import { ClipLoader } from 'react-spinners';
import { Tooltip } from 'react-tooltip';
import theme from 'container/theme';

const Notifications = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  const { notifications, next, unreadCount, loading } = useSelector(
    state => state.notifications
  );

  const menuRef = useRef(null);
  const menuListRef = useRef(null);

  const handleClickAway = () => {
    setOpen(false);
  };

  const handleLoadNotifications = () => {
    dispatch.notifications.loadMoreNotifications();
  };

  const handleWindowResize = () => {
    const width = menuRef.current.parentNode.parentNode.clientWidth;
    menuListRef.current.style.width = `${width - 10}px`;
  };

  const handleMarkAllRead = () => {
    if (unreadCount === 0) {
      return;
    }
    dispatch.notifications.readNotification();
  };

  useEffect(() => {
    handleWindowResize();
    dispatch.notifications.loadNotifications();
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container ref={menuRef}>
        <Menu onClick={() => setOpen(!open)}>
          <div className='notification-image' id='notification-tooltip'>
            <img src={assets.bell} alt='' />
            {unreadCount > 0 && (
              <span className='notification-count'>{unreadCount}</span>
            )}
          </div>
          <Tooltip
            anchorSelect='#notification-tooltip'
            content='Notifications'
            style={{ zIndex: '100', background: theme.colors.lightgrey }}
          />

          <MenuList
            ref={menuListRef}
            style={{ display: !open ? 'none' : 'flex', maxWidth: '309px' }}
          >
            <div className='header'>
              <p className='font-size-20'>Notifications</p>
              <p
                className='font-size-12 success'
                role='button'
                onClick={handleMarkAllRead}
              >
                Mark all as read
              </p>
            </div>
            <div className='notifcation-list'>
              {loading && (
                <div style={{ textAlign: 'center', marginTop: '100px' }}>
                  <ClipLoader size={20} color='#ffffff' />
                </div>
              )}
              {!loading &&
                notifications.length > 0 &&
                notifications.map(notification => (
                  <NotificationItem key={notification.id}>
                    <div className='icon'>
                      <img
                        src={
                          notification?.icon ? assets.tickGreen : assets.infoRed
                        }
                        alt=''
                      />
                    </div>
                    <div className='content'>
                      <p className='font-size-14'>{notification?.title}</p>
                      <p className='font-size-10'>
                        {notification?.notification}
                      </p>
                    </div>
                  </NotificationItem>
                ))}
              {!loading && !notifications.length && (
                <p className='font-size-14'>No notifications found</p>
              )}
            </div>
            {next && (
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ViewAllButton
                  role='button'
                  className='font-size-12 success'
                  onClick={handleLoadNotifications}
                >
                  Load more <img src={assets.arrowRightGreen} alt='' />
                </ViewAllButton>
              </div>
            )}
          </MenuList>
        </Menu>
      </Container>
    </ClickAwayListener>
  );
};

export default Notifications;

const Container = styled.div``;

const Menu = styled.div`
  height: 35px;
  width: 35px;
  background-color: ${({ theme }) => theme.colors.lightBlack};
  display: grid;
  place-items: center;
  border-radius: 7px;
  position: relative;
  & .notification-image {
    position: relative;
    cursor: pointer;

    & .notification-count {
      position: absolute;
      top: -2px;
      right: -2px;
      background-color: ${({ theme }) => theme.colors.red};
      color: #fff;
      line-height: 1;
      font-size: 6px;
      font-weight: 700;
      height: 10px;
      min-width: 10px;
      border-radius: 5px;
      text-align: center;
      padding: 2px;
    }
  }
`;

const MenuList = styled.div`
  padding: 12px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.lightBlack};
  position: absolute;
  bottom: 0px;
  right: 0px;
  transform: translate(0%, calc(100% + 20px));
  z-index: 100;
  color: ${({ theme }) => theme.colors.primary};
  height: 309px;
  display: flex;
  flex-direction: column;

  & .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  & .success {
    color: ${({ theme }) => theme.colors.green};
  }

  & .notifcation-list {
    height: 0px;
    flex-grow: 1;
    overflow: auto;
  }
`;

const ViewAllButton = styled.div`
  cursor: pointer;
`;

const NotificationItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;

  & .font-size-10 {
    opacity: 0.5;
  }
`;
